import { render, staticRenderFns } from "./editStatistics.vue?vue&type=template&id=13c8653e&scoped=true&"
import script from "./editStatistics.vue?vue&type=script&lang=js&"
export * from "./editStatistics.vue?vue&type=script&lang=js&"
import style0 from "./editStatistics.vue?vue&type=style&index=0&id=13c8653e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c8653e",
  null
  
)

export default component.exports